import {
  getPlatformV1Users,
  getPlatformV1UsersId,
  patchPlatformV1UsersId,
  postPlatformV1Users,
  postPlatformV1UsersIdResendWelcome,
  type GetPlatformV1Users200,
  type PatchPlatformV1UsersIdBody,
  type PlatformUser,
  type PostPlatformV1UsersBody,
} from '@nucleus-commerce/api-client/platform';

/** API layer: thin, typed wrappers over the generated client. The list is bounded (`{ items }`). */
export const usersApi = {
  list: (): Promise<GetPlatformV1Users200> => getPlatformV1Users(),
  get: (userId: string): Promise<PlatformUser> => getPlatformV1UsersId({ id: userId }),
  create: (input: PostPlatformV1UsersBody): Promise<PlatformUser> => postPlatformV1Users(input),
  update: (userId: string, input: PatchPlatformV1UsersIdBody): Promise<PlatformUser> =>
    patchPlatformV1UsersId({ id: userId }, input),
  resendWelcome: (userId: string): Promise<PlatformUser> =>
    postPlatformV1UsersIdResendWelcome({ id: userId }),
};
